// Others
import { urlApiVendors } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IDetailVendor,
  IFormVendor,
  IPayloadEditVendor,
  IQueryParamDetailVendor,
  IQueryParamVendors,
  IVendors,
} from '~/utils/interface/vendors';

const vendorsApi = {
  getListVendors: (params: IQueryParamVendors) => {
    const url = urlApiVendors.getListVendors;
    return axiosClient.get<IBaseResponse<IListDataResponse<IVendors[]>>>(url, { params });
  },

  createVendor: (body: IFormVendor) => {
    const url = urlApiVendors.createVendors;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  editVendor: (payload: IPayloadEditVendor) => {
    const { vendorId, body } = payload;
    const url = urlApiVendors.editVendors(vendorId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  getDetailVendor: (params: IQueryParamDetailVendor) => {
    const { vendorId, type, ...restParams } = params;
    const url = urlApiVendors.getDetailVendors(vendorId, type);
    return axiosClient.get<IBaseResponse<IDetailVendor>>(url, { params: restParams });
  },

  deleteVendor: (vendorId: string) => {
    const url = urlApiVendors.deleteVendor(vendorId);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default vendorsApi;
